<template>
    <div>
        <div class="setting-left" :style="`height:${columnH}px`">
            <ul>
                <li>
                    <router-link to="/main/primary/setting/signupSetting">报名单设置</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/notifySetting">提醒设置</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/groupingSetting">自动分组设置</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/reviewSetting">审核设置</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/sendMessage">发送短信</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/ticketWindcowSetting">窗口维护</router-link>
                </li>
                <li v-if="isShowByPermission('/recruitMessageTemplate/queryTemplateBySchoolId')">
                    <router-link to="/main/primary/setting/messageTemplateList">短信模板</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/setting/infoSearch/infoSearchList">信息查询</router-link>
                </li>
            </ul>
        </div>
        <div class="setting-right" :style="`height:${columnH}px`">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from '@/utils/utils';
import mixins from '@/mixins/windowResize';

export default {
    name: "SettingLayout",
    mixins:[mixins],
    methods: {
        isShowByPermission
    }
}
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .setting-left {
        float: left;
        width: 12%;
        border-right: 1px solid #e6e6e6;

        .router-link-active {
            color: #20a0ff;
        }
        ul {
            margin: 0;
            li {
                a {
                    text-decoration: none;
                    display: block;
                    height: 56px;
                    line-height: 56px;
                    font-size: 14px;
                    color: #48576a;
                    padding: 0 20px;
                    cursor: pointer;
                    position: relative;
                    transition: border-color .3s,background-color .3s,color .3s;
                    box-sizing: border-box;
                    white-space: nowrap;
                    &:hover {
                        background-color: #d1dbe5;
                    }
                }
            }
        }

    }
    .setting-right {
        float: right;
        width: 86%;
        overflow-y: auto;
    }

</style>



// WEBPACK FOOTER //
// src/views/primary/setting/SettingLayout.vue